import { useSystemStore } from './stores/system'

export default {
  set(path, params) {
    const systemStore = useSystemStore()
    const paramNames = Object.keys(params)
    if (paramNames.length === 0) {
      systemStore.overridePageTitle()
      return
    }

    /*
     * Note: This should only be used for tabbed pages that hook into the same model.
     * If you have a single page that needs to set a custom title, use the overridePageTitle
     * action from the system store on your module instead.
     */
    const map = [
      {
        key: 'network',
        route: /^\/networks\/list\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/networks/${params.network}`,
        attribute: 'name'
      },
      {
        key: 'client',
        route: /^\/clients\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/clients/${params.client}`,
        attribute: 'name'
      },
      {
        key: 'office',
        route: /^\/offices\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/offices/${params.office}`,
        attribute: 'name'
      },
      {
        key: 'user',
        route: /^\/users\/accounts\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/users/${params.user}`,
        attribute: 'name'
      },
      {
        key: 'feed',
        route: /^\/feeds\/list\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/feeds/${params.feed}`,
        attribute: (feed) => `${feed.office.name} ${feed.provider.name} Feed`
      },
      {
        key: 'printOrderImport',
        route: /^\/print\/imports\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/print-order-imports/${params.printOrderImport}`,
        attribute: 'name'
      },
      {
        key: 'aiAssistant',
        route: /^\/ai\/assistants\/([0-9]+)\/[^/]+$/,
        endpoint: `v3/ai-assistants/${params.aiAssistant}`,
        attribute: 'name'
      },
      {
        key: 'complianceCategory',
        route: /^\/compliance-guardian\/config\/([0-9]+)\/edit$/,
        endpoint: `v3/networks/${params.network}`,
        attribute: 'name'
      }
    ]

    const paramMap = map.find((m) => m.route.test(path))
    if (!paramMap) {
      systemStore.overridePageTitle()
      return
    }

    systemStore.setDynamicTitle(paramMap.key, paramMap.endpoint, paramMap.attribute)
  }
}
